import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import TabellaConfermaLaboratorio from "../TabellaConfermaLaboratorio/TabellaConfermaLaboratorio";
import RadioButton from "../../../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../../../utils/Utils";

class ConfermaDiLaboratorioRosolia extends Component {


    state = {
        confermaDiLaboratorioRosolia: {
            esamiEffettuati: "",

            ricercaIgm: "",
            ricercaIgmElisaOAltro: "",
            ricercaIgmAltroValore: "",
            dataRaccoltaCampioneRicergaIgm: "",
            esitoRicercaIgm: "",
            tipoCampioneRicercaIgm: "",
            eventualeAltroRicercaIgm: "",

            ricercaIgg: "",
            ricercaIggElisaOAltro: "",
            ricercaIggAltroValore: "",
            primaDataRaccoltaCampioneRicergaIgg: "",
            secondaDataRaccoltaCampioneRicergaIgg: "",
            esitoRicercaIgg: "",
            tipoCampioneRicercaIgg: "",
            eventualeAltroRicercaIgg: "",

            pcr: "",
            dataRaccoltaCampionePcr: "",
            esitoPcr: "",
            tipoCampionePcr: "",
            eventualeAltroPcr: "",

            altroTest: "",
            altroTestValore: "",
            dataRaccoltaCampioneAltroTest: "",
            esitoAltroTest: "",
            tipoCampioneAltroTest: "",
            eventualeAltroAltroTest: "",

            genotipizzazione: "",
            ceppoGenotipizzazione: "",

            corretto: []

        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
        this.controlloCorrettezza = this.controlloCorrettezza.bind(this)
    }

    componentDidMount() {
        let confermaDiLaboratorioRosolia = this.state.confermaDiLaboratorioRosolia

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale &&
            this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio && this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio.rosolia) {
            let confermaDiLaboratorioRosoliaCopia = this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio.rosolia
            for (let key in confermaDiLaboratorioRosolia) {
                if (confermaDiLaboratorioRosolia.hasOwnProperty(key) === confermaDiLaboratorioRosoliaCopia.hasOwnProperty(key)) {
                    confermaDiLaboratorioRosolia[key] = confermaDiLaboratorioRosoliaCopia[key]
                } else {
                    confermaDiLaboratorioRosolia[key] = ""
                }
            }
            this.setState({confermaDiLaboratorioRosolia: confermaDiLaboratorioRosolia})
            this.controlloCorrettezza()
            this.props.updateConferme({
                confermaDiLaboratorioRosolia: confermaDiLaboratorioRosolia,
                corretto: confermaDiLaboratorioRosolia.corretto
            })

        } else {
            this.controlloCorrettezza()
            this.props.updateConferme({
                confermaDiLaboratorioRosolia: confermaDiLaboratorioRosolia,
                corretto: confermaDiLaboratorioRosolia.corretto
            })
        }
        Utils.disabledDateTabellaConfermaLaboratorio("Rosolia", this.state)
    }

    riceviValore(field, event) {
        let confermaDiLaboratorioRosolia = this.state.confermaDiLaboratorioRosolia
        let fieldFinale = field.replace("Rosolia", "")
        confermaDiLaboratorioRosolia[fieldFinale] = event.target.value
        if (confermaDiLaboratorioRosolia.esamiEffettuati !== "1") {
            confermaDiLaboratorioRosolia.ricercaIgm = ""
            confermaDiLaboratorioRosolia.ricercaIgmElisaOAltro = ""
            confermaDiLaboratorioRosolia.ricercaIgmAltroValore = ""
            confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm = ""
            confermaDiLaboratorioRosolia.esitoRicercaIgm = ""
            confermaDiLaboratorioRosolia.tipoCampioneRicercaIgm = ""
            confermaDiLaboratorioRosolia.eventualeAltroRicercaIgm = ""
            confermaDiLaboratorioRosolia.ricercaIgg = ""
            confermaDiLaboratorioRosolia.ricercaIgmElisaOAltro = ""
            confermaDiLaboratorioRosolia.ricercaIggAltroValore = ""
            confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioRosolia.esitoRicercaIgg = ""
            confermaDiLaboratorioRosolia.tipoCampioneRicercaIgg = ""
            confermaDiLaboratorioRosolia.eventualeAltroRicercaIgg = ""
            confermaDiLaboratorioRosolia.pcr = ""
            confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr = ""
            confermaDiLaboratorioRosolia.esitoPcr = ""
            confermaDiLaboratorioRosolia.eventualeAltroPcr = ""
            confermaDiLaboratorioRosolia.tipoCampionePcr = ""
            confermaDiLaboratorioRosolia.altroTest = ""
            confermaDiLaboratorioRosolia.altroTestValore = ""
            confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest = ""
            confermaDiLaboratorioRosolia.esitoAltroTest = ""
            confermaDiLaboratorioRosolia.tipoCampioneAltroTest = ""
            confermaDiLaboratorioRosolia.eventualeAltroAltroTest = ""
            confermaDiLaboratorioRosolia.genotipizzazione = ""
            confermaDiLaboratorioRosolia.ceppoGenotipizzazione = ""
        }

        if (confermaDiLaboratorioRosolia.ricercaIgm !== "true") {
            confermaDiLaboratorioRosolia.ricercaIgm = ""
            confermaDiLaboratorioRosolia.ricercaIgmElisaOAltro = ""
            confermaDiLaboratorioRosolia.ricercaIgmAltroValore = ""
            confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm = ""
            confermaDiLaboratorioRosolia.esitoRicercaIgm = ""
            confermaDiLaboratorioRosolia.tipoCampioneRicercaIgm = ""
            confermaDiLaboratorioRosolia.eventualeAltroRicercaIgm = ""
        }
        if (confermaDiLaboratorioRosolia.ricercaIgg !== "true") {
            confermaDiLaboratorioRosolia.ricercaIgg = ""
            confermaDiLaboratorioRosolia.ricercaIggElisaOAltro = ""
            confermaDiLaboratorioRosolia.ricercaIggAltroValore = ""
            confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg = ""
            confermaDiLaboratorioRosolia.esitoRicercaIgg = ""
            confermaDiLaboratorioRosolia.tipoCampioneRicercaIgg = ""
            confermaDiLaboratorioRosolia.eventualeAltroRicercaIgg = ""
        }
        if (confermaDiLaboratorioRosolia.pcr !== "true") {
            confermaDiLaboratorioRosolia.pcr = ""
            confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr = ""
            confermaDiLaboratorioRosolia.esitoPcr = ""
            confermaDiLaboratorioRosolia.eventualeAltroPcr = ""
            confermaDiLaboratorioRosolia.tipoCampionePcr = ""
        }
        if (confermaDiLaboratorioRosolia.altroTest !== "true") {
            confermaDiLaboratorioRosolia.altroTest = ""
            confermaDiLaboratorioRosolia.altroTestValore = ""
            confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest = ""
            confermaDiLaboratorioRosolia.esitoAltroTest = ""
            confermaDiLaboratorioRosolia.tipoCampioneAltroTest = ""
            confermaDiLaboratorioRosolia.eventualeAltroAltroTest = ""
        }
        if (confermaDiLaboratorioRosolia.genotipizzazione !== "true") {
            confermaDiLaboratorioRosolia.genotipizzazione = ""
            confermaDiLaboratorioRosolia.ceppoGenotipizzazione = ""
        }
        if (confermaDiLaboratorioRosolia.ricercaIgmElisaOAltro !== "2") {
            confermaDiLaboratorioRosolia.ricercaIgmAltroValore = ""
        }
        if (confermaDiLaboratorioRosolia.ricercaIggElisaOAltro !== "2") {
            confermaDiLaboratorioRosolia.ricercaIggAltroValore = ""
        }
        this.setState({confermaDiLaboratorioRosolia: confermaDiLaboratorioRosolia})
        this.controlloCorrettezza()
        Utils.disabledDateTabellaConfermaLaboratorio("Rosolia", this.state)
        this.props.updateConferme({
            confermaDiLaboratorioRosolia: confermaDiLaboratorioRosolia,
            corretto: confermaDiLaboratorioRosolia.corretto
        })
    }


    controlloCorrettezza() {
        let confermaDiLaboratorioRosolia = this.state.confermaDiLaboratorioRosolia
        confermaDiLaboratorioRosolia.corretto = []

        if (confermaDiLaboratorioRosolia.esamiEffettuati === "1") {
            if (!confermaDiLaboratorioRosolia.ricercaIgg && !confermaDiLaboratorioRosolia.ricercaIgm &&
                !confermaDiLaboratorioRosolia.pcr && !confermaDiLaboratorioRosolia.altroTest) {
                confermaDiLaboratorioRosolia.corretto[6] = "Campo \"Tipo esame\" mancante";
            }
            if(confermaDiLaboratorioRosolia.ricercaIgm === "true"){
                if(!confermaDiLaboratorioRosolia.ricercaIgmElisaOAltro) confermaDiLaboratorioRosolia.corretto[6] = "Campo \"Tipo esame\" mancante";
                if((!confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm || (confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm), "-")))){
                    confermaDiLaboratorioRosolia.corretto[7] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioRosolia.esitoRicercaIgm )  confermaDiLaboratorioRosolia.corretto[8] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioRosolia.tipoCampioneRicercaIgm || (confermaDiLaboratorioRosolia.tipoCampioneRicercaIgm === "3" && !confermaDiLaboratorioRosolia.eventualeAltroRicercaIgm))  confermaDiLaboratorioRosolia.corretto[9] = "Campo \"Tipo di campione\" mancante";
                if(confermaDiLaboratorioRosolia.ricercaIgmElisaOAltro === "2" && !confermaDiLaboratorioRosolia.ricercaIgmAltroValore) confermaDiLaboratorioRosolia.corretto[6] = "Campo \"Tipo esame\" mancante";
            }
            if (confermaDiLaboratorioRosolia.ricercaIgg === "true"){
                if(!confermaDiLaboratorioRosolia.ricercaIggElisaOAltro) confermaDiLaboratorioRosolia.corretto[6] = "Campo \"Tipo esame\" mancante";
                if((!confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg  || (confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg), "-")) ||
                    !confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg || (confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg), "-")))){
                    confermaDiLaboratorioRosolia.corretto[7] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioRosolia.esitoRicercaIgg )  confermaDiLaboratorioRosolia.corretto[8] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioRosolia.tipoCampioneRicercaIgg || (confermaDiLaboratorioRosolia.tipoCampioneRicercaIgg === "3" && !confermaDiLaboratorioRosolia.eventualeAltroRicercaIgg))  confermaDiLaboratorioRosolia.corretto[9] = "Campo \"Tipo di campione\" mancante";
                if(confermaDiLaboratorioRosolia.ricercaIggElisaOAltro === "2" && !confermaDiLaboratorioRosolia.ricercaIggAltroValore) confermaDiLaboratorioRosolia.corretto[6] = "Campo \"Tipo esame\" mancante";
            }
            if (confermaDiLaboratorioRosolia.pcr === "true"){
                if(!confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr || (confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr &&
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr),"-"))){
                    confermaDiLaboratorioRosolia.corretto[7] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioRosolia.esitoPcr) confermaDiLaboratorioRosolia.corretto[8] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioRosolia.tipoCampionePcr || (confermaDiLaboratorioRosolia.tipoCampionePcr === "4" && !confermaDiLaboratorioRosolia.eventualeAltroPcr)) confermaDiLaboratorioRosolia.corretto[9] = "Campo \"Tipo di campione\" mancante";
            }
            if (confermaDiLaboratorioRosolia.altroTest === "true"){
                if(!confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest || !confermaDiLaboratorioRosolia.altroTestValore ||
                    Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest), "-")){
                    confermaDiLaboratorioRosolia.corretto[7] = "Campo \"Data Raccolta Campione\" mancante";
                }
                if(!confermaDiLaboratorioRosolia.esitoAltroTest) confermaDiLaboratorioRosolia.corretto[8] = "Campo \"Esito\" mancante";
                if(!confermaDiLaboratorioRosolia.tipoCampioneAltroTest || (confermaDiLaboratorioRosolia.tipoCampioneAltroTest === "4" && !confermaDiLaboratorioRosolia.eventualeAltroAltroTest)) confermaDiLaboratorioRosolia.corretto[9] = "Campo \"Tipo di campione\" mancante";
            }
            if (confermaDiLaboratorioRosolia.genotipizzazione === "true" && !confermaDiLaboratorioRosolia.ceppoGenotipizzazione) {
                confermaDiLaboratorioRosolia.corretto[6] = "Campo \"Tipo esame\" mancante";
            }
        }
        else if (confermaDiLaboratorioRosolia.esamiEffettuati !== "2") confermaDiLaboratorioRosolia.corretto[5] = "Campo \"Effettuati esami di laboratorio per la diagnosi di rosolia?\" mancante";

        this.setState({confermaDiLaboratorioRosolia: confermaDiLaboratorioRosolia})
    }

    render() {
        const {t} = this.props

        const info = (
            <div>
                <p style={{fontSize: "12px", fontWeight: "bold"}}>
                    {t("SchedaSpecialeMorbillo.misurazione")}</p>
            </div>
        )

        const intestazione = (
            <div>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.effettuatiEsamiRosolia")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>

                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <RadioButton id={"effettuatiEsamiRosoliaSi"} name={"esamiEffettuatiRosolia"}
                                         label={t("SchedaSpecialeMorbillo.si")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.confermaDiLaboratorioRosolia.esamiEffettuati === "1"}>
                            </RadioButton>
                            <RadioButton id={"effettuatiEsamiRosoliaNo"} name={"esamiEffettuatiRosolia"}
                                         label={t("SchedaSpecialeMorbillo.no")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"2"}
                                         checked={this.state.confermaDiLaboratorioRosolia.esamiEffettuati === "2"}>
                            </RadioButton>
                        </div>
                    </div>
                </div>
                <u style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginTop: "0.5rem"
                }}>{t("SchedaSpecialeMorbillo.rosolia")}</u>
            </div>
        )


        return (
            <div style={{marginTop: "1rem"}}>
                {intestazione}
                <fieldset disabled={this.state.confermaDiLaboratorioRosolia.esamiEffettuati === "1" ? false : true}>
                    <TabellaConfermaLaboratorio id={"Rosolia"}
                                                confermaDiLaboratorio={this.state.confermaDiLaboratorioRosolia}
                                                riceviValore={this.riceviValore}
                                                segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>
                </fieldset>
                {info}
            </div>
        );
    }

}

export default withTranslation('common')(ConfermaDiLaboratorioRosolia)
